var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1209 9.00031L17.0584 3.06281C17.3402 2.78152 17.4987 2.3998 17.4991 2.00164C17.4994 1.60348 17.3416 1.22148 17.0603 0.939688C16.779 0.657896 16.3973 0.499389 15.9991 0.499037C15.601 0.498686 15.219 0.656518 14.9372 0.937813L8.99967 6.87531L3.06217 0.937813C2.78038 0.656021 2.39819 0.497711 1.99967 0.497711C1.60116 0.497711 1.21896 0.656021 0.937172 0.937813C0.65538 1.21961 0.49707 1.6018 0.49707 2.00031C0.49707 2.39883 0.65538 2.78102 0.937172 3.06281L6.87467 9.00031L0.937172 14.9378C0.65538 15.2196 0.49707 15.6018 0.49707 16.0003C0.49707 16.3988 0.65538 16.781 0.937172 17.0628C1.21896 17.3446 1.60116 17.5029 1.99967 17.5029C2.39819 17.5029 2.78038 17.3446 3.06217 17.0628L8.99967 11.1253L14.9372 17.0628C15.219 17.3446 15.6012 17.5029 15.9997 17.5029C16.3982 17.5029 16.7804 17.3446 17.0622 17.0628C17.344 16.781 17.5023 16.3988 17.5023 16.0003C17.5023 15.6018 17.344 15.2196 17.0622 14.9378L11.1209 9.00031Z",
    fill: "#7E898F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSilver);
export default __webpack_public_path__ + "static/media/CloseSilver.12b32a96078268a0cadda93f279c48c7.svg";
export { ForwardRef as ReactComponent };